import React from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import { EditOutlined, DeleteOutlined } from "@material-ui/icons";

const TipoDeConvenio = ({
  tipoDeConvenio,
  index,
  handleEdit,
  handleOpenExclusaoTipoDeConvenio,
}) => {
  return (
    <div
      className={
        index % 2 === 0
          ? "row mt-0 d-flex align-items-center medium-row tr-even-adm"
          : "row mt-0 d-flex align-items-center medium-row tr-odd"
      }
    >
      <div className="col-2 col-md-2 mt-sm-2 mt-lg-0 user-table ">
        <span>{tipoDeConvenio.tipoConvenio}</span>
      </div>
      <div className="col-12 col-md-9 my-2 my-lg-0 user-table">
        <span>{tipoDeConvenio.nome}</span>
      </div>
      <Tooltip title="Editar">
        <IconButton className="p-2" onClick={() => handleEdit(tipoDeConvenio)}>
          <EditOutlined className={"color-black"} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Excluir">
        <IconButton
          className="p-2"
          onClick={() => handleOpenExclusaoTipoDeConvenio(tipoDeConvenio)}
        >
          <DeleteOutlined className={"color-black"} />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default TipoDeConvenio;
